export default __webpack_public_path__ + "static/media/avatar_merlion6.e907272e.mp3";